module.exports = __webpack_public_path__ + "bf9d5831af65689614ffe230ad210e60.png";